import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { deleteVisitActions } from '../../../redux/actions/visitActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';

const DeleteVisitModal = ({ onModalClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { vin, id } = useSelector((state) => state.visit?.visit);

  const onSubmit = async () => {
    setLoading(true);
    await dispatch(deleteVisitActions(vin, id));
    setLoading(false);
    navigate(`/vehicles/${vin}`);
  };

  return (
    <Modal
      title={'Видалення візиту'}
      loading={loading}
      onClose={onModalClose}
      body={'Ви дійсно бажаєте видалити цей візит?'}
      actionButton={<Button onClick={onSubmit} disabled={loading} variant={'primary'} children={'Видалити'} />}
    />
  );
};

export default DeleteVisitModal;
